"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoutiqueNavItems = exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
var _navConstants = require("../constants/navConstants");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Used in web-nav, web-preauth, web-registry, web-store
 */

var createSubCategory = function createSubCategory(categories, isGuest) {
  return categories.map(function (category) {
    var _category$path, _category$children;
    var giftsAndFavors = category.path === '/shop/category/wedding-gifts-favors';
    var intimates = category.path === '/shop/category/wedding-intimates';
    var partySupplies = category.path === '/shop/category/party-supplies-decor';
    var beautyAndWellness = category.path === '/shop/category/health-wellness';
    var id = (_category$path = category.path) === null || _category$path === void 0 ? void 0 : _category$path.substring(category.path.lastIndexOf('/') + 1);
    var dropdownItems = (_category$children = category.children) === null || _category$children === void 0 ? void 0 : _category$children.map(function (child) {
      var _child$children;
      return _objectSpread(_objectSpread({}, child), {}, {
        businessUnit: 'REGISTRY',
        children: (_child$children = child.children) === null || _child$children === void 0 ? void 0 : _child$children.map(function (grandchild) {
          return _objectSpread(_objectSpread({}, grandchild), {}, {
            businessUnit: 'REGISTRY'
          });
        })
      });
    });
    return {
      id: id,
      title: !isGuest && category.title === 'Bridal Boutique' ? 'Bridal' : category.title,
      path: category.path,
      dropdownItems: dropdownItems,
      showCaret: false,
      dockRight: intimates || beautyAndWellness,
      centerDropdown: partySupplies || giftsAndFavors,
      parent: _navConstants.PrimaryNavIdentifier.WEDDING_BOUTIQUE,
      businessUnit: 'REGISTRY'
    };
  });
};
var getBoutiqueNavItems = exports.getBoutiqueNavItems = function getBoutiqueNavItems(userContext, weddingShopApiResponse) {
  var isGuest = userContext ? Boolean(userContext.is_guest) : true;
  var categories = weddingShopApiResponse === null || weddingShopApiResponse === void 0 ? void 0 : weddingShopApiResponse.categories;
  if (!categories) return [];
  return [{
    id: 'new-arrivals',
    title: isGuest ? 'New Arrivals' : 'New',
    path: '/shop/collection/wedding-shop-new-arrivals',
    parent: _navConstants.PrimaryNavIdentifier.WEDDING_BOUTIQUE,
    businessUnit: 'REGISTRY'
  }].concat(_toConsumableArray(createSubCategory(categories, isGuest)), [{
    id: 'invites-and-paper',
    title: 'Invites & Paper',
    path: isGuest ? '/wedding-planning/paper' : '/wedding-planning/universal',
    parent: _navConstants.PrimaryNavIdentifier.WEDDING_BOUTIQUE,
    businessUnit: 'PAPER'
  }]);
};
var _default = exports.default = getBoutiqueNavItems;